import React from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';

export function BottomDock(props) {
  const links = [
    { url: '/about', title: 'ABOUT', icon: 'nav-icon-ABOUT.png', iconHover: 'nav-icon-ABOUT.png' },
    { url: '/members-area', title: 'MEMBERS', icon: 'nav-icon-MEMBERS.png', iconHover: 'nav-icon-MEMBERS.png' },
    { url: '/specimens', title: 'SPECIMENS', icon: 'nav-icon-SPECIMENS.png', iconHover: 'nav-icon-SPECIMENS.png' },
    { url: '/events', title: 'EVENTS', icon: 'nav-icon-EVENTS.png', iconHover: 'nav-icon-EVENTS.png' },
    { url: '/contact', title: 'CONTACT', icon: 'nav-icon-CONTACT.png', iconHover: 'nav-icon-CONTACT.png' }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index}`}>
        <div className="icon">
          <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
          <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  );

  // const bottomMenu = useRef(null);
  // useLayoutEffect(() => {
  //   //console.log('useLayoutEffect');
  //   const slider = new BottomDrawer(bottomMenu.current);
  //   setTimeout(() => slider.init(), 1000)
  // }, [])

  return (
    <>
      {/* <nav className="bottomMenu" ref={bottomMenu}>
        <div className="bottomMenu__bar">
          <div className="bottomMenu__line1"></div>
          <div className="bottomMenu__line2"></div>
        </div> */}
        {/* <div className="bottomMenu__bg"></div> */}
        {/* <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav> */}
      {/* <div className="bottomMenuPadding"></div> */}
      <nav className="bottomMenu">
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
    </>
  );
}
